"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AuthenticateError_component_js_1 = __importDefault(require("./core/default-component/AuthenticateError.component.js"));
const index_js_1 = require("./core/default-component/index.js");
const ServiceWorkerNotSupported_component_js_1 = __importDefault(require("./core/default-component/ServiceWorkerNotSupported.component.js"));
const OidcRoutes_js_1 = __importDefault(require("./core/routes/OidcRoutes.js"));
const vanillaOidc_js_1 = require("./vanilla/vanillaOidc.js");
const defaultEventState = { name: '', data: null };
const OidcSession = ({ loadingComponent, children, configurationName }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        if (oidc) {
            oidc.tryKeepExistingSessionAsync().then(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });
        }
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    const LoadingComponent = loadingComponent;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isLoading
            ? ((0, jsx_runtime_1.jsx)(LoadingComponent, { configurationName: configurationName }))
            : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })) }));
};
const Switch = ({ isLoading, loadingComponent, children, configurationName }) => {
    const LoadingComponent = loadingComponent;
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(LoadingComponent, Object.assign({ configurationName: configurationName }, { children: children }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
const OidcProvider = ({ children, configuration, configurationName = 'default', callbackSuccessComponent = index_js_1.CallBackSuccess, authenticatingComponent = index_js_1.Authenticating, loadingComponent = index_js_1.Loading, serviceWorkerNotSupportedComponent = ServiceWorkerNotSupported_component_js_1.default, authenticatingErrorComponent = AuthenticateError_component_js_1.default, sessionLostComponent = index_js_1.SessionLost, onSessionLost = null, onLogoutFromAnotherTab = null, onLogoutFromSameTab = null, withCustomHistory = null, onEvent = null, }) => {
    const getOidc = (configurationName = 'default') => {
        return vanillaOidc_js_1.VanillaOidc.getOrCreate(configuration, configurationName);
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [event, setEvent] = (0, react_1.useState)(defaultEventState);
    const [currentConfigurationName, setConfigurationName] = (0, react_1.useState)('default');
    (0, react_1.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (onEvent) {
                onEvent(configurationName, name, data);
            }
        });
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName, onEvent]);
    (0, react_1.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc_js_1.VanillaOidc.eventNames.refreshTokensAsync_error || name === vanillaOidc_js_1.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (onSessionLost != null) {
                    onSessionLost();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_another_tab) {
                if (onLogoutFromAnotherTab != null) {
                    onLogoutFromAnotherTab();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_same_tab) {
                if (onLogoutFromSameTab != null) {
                    onLogoutFromSameTab();
                }
                // setEvent({name, data});
            }
            else if (name === vanillaOidc_js_1.VanillaOidc.eventNames.loginAsync_begin ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.loginCallbackAsync_end ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.loginAsync_error ||
                name === vanillaOidc_js_1.VanillaOidc.eventNames.loginCallbackAsync_error) {
                setEvent({ name, data });
            }
            else if (name === vanillaOidc_js_1.VanillaOidc.eventNames.service_worker_not_supported_by_browser && configuration.service_worker_only === true) {
                setEvent({ name, data });
            }
        });
        setConfigurationName(configurationName);
        setLoading(false);
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
            setEvent(defaultEventState);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configuration, configurationName]);
    const SessionLostComponent = sessionLostComponent;
    const AuthenticatingComponent = authenticatingComponent;
    const LoadingComponent = loadingComponent;
    const ServiceWorkerNotSupportedComponent = serviceWorkerNotSupportedComponent;
    const AuthenticatingErrorComponent = authenticatingErrorComponent;
    const isLoading = (loading || (currentConfigurationName !== configurationName));
    const oidc = getOidc(configurationName);
    const eventName = event.name;
    switch (eventName) {
        case vanillaOidc_js_1.VanillaOidc.eventNames.service_worker_not_supported_by_browser:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(ServiceWorkerNotSupportedComponent, { configurationName: configurationName }) })));
        case vanillaOidc_js_1.VanillaOidc.eventNames.loginAsync_begin:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(AuthenticatingComponent, { configurationName: configurationName }) })));
        case vanillaOidc_js_1.VanillaOidc.eventNames.loginAsync_error:
        case vanillaOidc_js_1.VanillaOidc.eventNames.loginCallbackAsync_error:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(AuthenticatingErrorComponent, { configurationName: configurationName }) })));
        case vanillaOidc_js_1.VanillaOidc.eventNames.refreshTokensAsync_error:
        case vanillaOidc_js_1.VanillaOidc.eventNames.syncTokensAsync_error:
        case vanillaOidc_js_1.VanillaOidc.eventNames.logout_from_another_tab:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(SessionLostComponent, { configurationName: configurationName }) })));
        default:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(OidcRoutes_js_1.default, Object.assign({ redirect_uri: oidc.configuration.redirect_uri, silent_redirect_uri: oidc.configuration.silent_redirect_uri, silent_login_uri: oidc.configuration.silent_login_uri, callbackSuccessComponent: callbackSuccessComponent, callbackErrorComponent: authenticatingErrorComponent, authenticatingComponent: authenticatingComponent, configurationName: configurationName, withCustomHistory: withCustomHistory }, { children: (0, jsx_runtime_1.jsx)(OidcSession, Object.assign({ loadingComponent: LoadingComponent, configurationName: configurationName }, { children: children })) })) })));
    }
};
exports.OidcProvider = OidcProvider;
exports.default = exports.OidcProvider;
//# sourceMappingURL=OidcProvider.js.map